<template>
  <div class="personal-page">
    <section class="profile-hero">
      <div class="profile-inner">
        <div class="profile-main">
          <input type="file" @change="uploadImage" style="display: none" ref="fileInput">
          <img class="profile-avatar pointer" :src="imageSrc" @click="openFileInput"/>
          <div class="profile-copy">
            <div class="profile-name-row">
              <span v-if="!magEnable" class="level-badge">{{ userInfo.level }}</span>
              <h1>{{ userInfo.name }}</h1>
              <router-link class="password-link" :to="{ name: 'Updated-password'}">修改密碼</router-link>
            </div>
            <div class="profile-meta">
              <span v-if="userInfo.enterprise_name">公司：{{ userInfo.enterprise_name }}</span>
              <span>班級：{{ userInfo.group_name }}</span>
              <span>課程時間：{{ segment }}</span>
            </div>
            <button type="button" v-if="role !== 'user'" @click="goPage('HR')" class="hr-btn">HR 專區</button>
          </div>
        </div>

        <div class="profile-stats" v-if="target">
          <div class="stat-card">
            <span>學習總時數</span>
            <strong>{{ target.time ? target.time.user : '00:00:00' }}</strong>
          </div>
          <div class="stat-card">
            <span>通過單元測驗數</span>
            <strong>{{ target.course ? target.course.user : 0 }}</strong>
          </div>
          <div class="stat-card" v-if="!magEnable">
            <span>月考次數</span>
            <strong>{{ target.exam ? target.exam.user : 0 }}</strong>
          </div>
        </div>
      </div>
    </section>

    <nav class="personal-tabs">
      <div class="tabs-inner">
        <button type="button" @click="goPage('Target')" :class="{ active: $route.name === 'Target' }">學習目標</button>
        <button type="button" @click="goPage('Record')" :class="{ active: $route.name === 'Record' }">學習記錄</button>
        <button type="button" @click="goPage('Collections')" :class="{ active: $route.name === 'Collections' }">我的收藏</button>
        <button type="button" v-if="!magEnable" @click="goPage('Exam-area')" :class="{ active: $route.name === 'Exam-area' }">測驗專區</button>
        <button type="button" v-if="!magEnable" @click="goPage('Challenge')" :class="{ active: $route.name === 'Challenge' }">單字挑戰</button>
      </div>
    </nav>

    <main class="personal-content">
      <router-view :target="target"></router-view>
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '../store/api'

export default {
  name: 'Personal',
  data () {
    return {
      personalData: {},
      target: {},
      groupId: 0,
      imageSrc: ''
    }
  },
  computed: {
    segment () {
      return this.moment(this.userInfo.group_begin_at).format('YYYY-MM-DD') + ' ~ ' + this.moment(this.userInfo.group_end_at).format('YYYY-MM-DD')
    },
    ...mapGetters([
      'role',
      'authInfo',
      'userInfo'
    ]),
    magEnable () {
      return Boolean(this.authInfo.user && this.authInfo.user.magEnable)
    },
  },
  mounted() {
    this.getTarget(this.userInfo.student_id)
    this.scrollTop()
    this.getPersonalData()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    goPage (el) {
      this.$router.push({ name: el})
      if (el === 'HR') {
        this.$router.push({ name: 'Overview', params: {type: 'summary', groupId: this.userInfo.group_id}})
      }
    },
    async getTarget (id) {
      const { data } = await api.get(`/me/records`)
      this.target = data.data
      this.target.segment = this.segment
      this.target.standard = this.userInfo.enterprise_standard
    },
    getPersonalData () {
      this.imageSrc = this.userInfo.avatar
    },
    openFileInput() {
      this.$refs.fileInput.click()
    },
    uploadImage(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = () => {
          this.imageSrc = reader.result
          this.updatedAvatar(file)
        }
        reader.readAsDataURL(file)
      }
    },
    async updatedAvatar(file) {
      const fileData = new window.FormData()
      fileData.append('file', file)
      await api.post(`update_avatar`, fileData)
      await this.getUser()
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-page {
  min-height: calc(100vh - 93px);
  background: #f4f7fa;
}

.profile-hero {
  min-height: 250px;
  height: 30vh;
  background-image: url('../assets/image/pic/bg_member_top.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.profile-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  max-width: 1100px;
  min-height: 250px;
  height: 100%;
  margin: 0 auto;
  padding: 32px 0;
}

.profile-main {
  display: flex;
  align-items: center;
  gap: 22px;
  min-width: 0;
}

.profile-avatar {
  width: 100px;
  height: 100px;
  flex: 0 0 100px;
  object-fit: cover;
  border: 1px solid #e0b439;
  border-radius: 50%;
}

.profile-copy {
  min-width: 0;
  color: #fff;
  text-align: left;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.level-badge {
  min-width: 38px;
  padding: 3px 8px;
  color: #08294a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  background: #f5c425;
  border-radius: 2px;
}

.profile-name-row h1 {
  margin: 0;
  color: #fff;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.password-link {
  color: rgba(255, 255, 255, .58);
  font-size: 14px;
}

.password-link:hover {
  color: #fff;
}

.profile-meta {
  display: flex;
  gap: 24px;
  flex-wrap: nowrap;
  color: rgba(255, 255, 255, .76);
  font-size: 12px;
}

.profile-meta span {
  white-space: nowrap;
}

.hr-btn {
  margin-top: 12px;
  padding: 5px 12px;
  color: #fff;
  font-size: 15px;
  background: rgba(255, 255, 255, .14);
  border: 1px solid rgba(255, 255, 255, .22);
  border-radius: 4px;
}

.profile-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  flex: 0 0 470px;
}

.stat-card {
  min-height: 78px;
  padding: 16px 20px;
  text-align: left;
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .22);
  border-radius: 5px;
}

.stat-card span {
  display: block;
  margin-bottom: 9px;
  color: rgba(255, 255, 255, .52);
  font-size: 12px;
  white-space: nowrap;
}

.stat-card strong {
  color: #fff;
  font-size: 23px;
  line-height: 1;
  white-space: nowrap;
}

.personal-tabs {
  background: #fff;
  border-bottom: 1px solid #d7e0e8;
}

.tabs-inner {
  display: flex;
  gap: 30px;
  max-width: 1100px;
  height: 64px;
  margin: 0 auto;
  overflow-x: auto;
}

.tabs-inner button {
  position: relative;
  padding: 0 0 3px;
  color: #85a0b5;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  background: transparent;
  border: 0;
}

.tabs-inner button.active {
  color: #113b5a;
}

.tabs-inner button.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: #f5a623;
}

.personal-content {
  max-width: 1100px;
  margin: 0 auto;
}

@media (max-width: 1199px) {
  .profile-inner,
  .tabs-inner,
  .personal-content {
    max-width: none;
    margin-left: 24px;
    margin-right: 24px;
  }
}

@media (max-width: 991px) {
  .profile-hero {
    height: auto;
  }

  .profile-inner {
    align-items: flex-start;
    flex-direction: column;
    gap: 22px;
    min-height: 0;
    height: auto;
  }

  .profile-stats {
    width: 100%;
    flex-basis: auto;
    gap: 14px;
  }

  .profile-meta {
    flex-wrap: wrap;
  }
}

@media (max-width: 767px) {
  .profile-inner,
  .tabs-inner,
  .personal-content {
    margin-left: 16px;
    margin-right: 16px;
  }

  .profile-inner {
    gap: 18px;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .profile-main {
    align-items: flex-start;
    gap: 14px;
    width: 100%;
  }

  .profile-avatar {
    width: 58px;
    height: 58px;
    flex-basis: 58px;
  }

  .profile-name-row {
    gap: 8px;
    margin-bottom: 10px;
  }

  .profile-name-row h1 {
    max-width: 100%;
    font-size: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .profile-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .stat-card {
    min-height: 66px;
    padding: 13px 16px;
  }

  .profile-meta {
    flex-wrap: wrap;
    gap: 8px;
  }

  .profile-meta span {
    white-space: normal;
  }

  .tabs-inner {
    gap: 22px;
    height: 56px;
  }
}
</style>
